import { Outlet } from 'react-router-dom';

// project-imports
import Drawer from './Drawer';
import Footer from './Footer';
import Header from './Header';
import Breadcrumbs from 'components/Breadcrumbs';

// ==============================|| MAIN LAYOUT ||============================== //

export default function MainLayout() {
  return (
    <>
      <Drawer />
      <Header />
      <div className="pc-container">
        <div className="pc-content">
          <Breadcrumbs />
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
